import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { toast } from "sonner";
import { PageHeader } from "../components/PageHeader";
import { FadeUp } from "../components/Reveal";
import { api } from "../lib/api";

export default function Insights() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/posts").then((r) => setPosts(r.data)).catch(() => toast.error("Could not load insights."));
  }, []);

  return (
    <>
      <PageHeader
        testId="insights-page"
        overline="Insights"
        title={["Field notes from the", "frontlines of health tech."]}
        subtitle="Essays and lessons from our work across bioinformatics, genomics, analytics, and patient experience."
      />
      <section className="pb-24 lg:pb-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 grid gap-6 md:grid-cols-2" data-testid="insights-grid">
          {posts.map((post, i) => (
            <FadeUp key={post.id} delay={i * 0.06}>
              <Link
                to={`/insights/${post.slug}`}
                data-testid={`insight-card-${post.slug}`}
                className="group block h-full rounded-3xl border border-primary/10 bg-white overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:border-accent/50 hover:shadow-xl hover:shadow-accent/10"
              >
                <div className="aspect-[16/9] overflow-hidden">
                  <img src={post.image} alt={post.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                </div>
                <div className="p-8">
                  <div className="flex items-center gap-3 text-xs">
                    <span className="font-bold tracking-[0.15em] uppercase text-accent">{post.category}</span>
                    <span className="text-muted-foreground">{post.date} · {post.read_time}</span>
                  </div>
                  <h2 className="mt-4 font-display text-2xl font-medium tracking-tight text-foreground leading-snug">{post.title}</h2>
                  <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{post.excerpt}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-primary group-hover:text-accent transition-colors">
                    Read article <ArrowUpRight size={16} weight="bold" />
                  </span>
                </div>
              </Link>
            </FadeUp>
          ))}
          {posts.length === 0 && <p className="text-sm text-muted-foreground">Loading insights…</p>}
        </div>
      </section>
    </>
  );
}
